module.exports = __webpack_public_path__ + "static/img/16bg_5.59d998d.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/background/16bg_5.png
// module id = 661
// module chunks = 1